const { postMethod } = require('../common/api');

const updateCookieToUserMetadata = async (params) => {
  return postMethod('/api/cookie/update', params);
};

export default updateCookieToUserMetadata;
